
export default {
  layout: 'MainLayout',
  name: 'LoginPage',
  components: {},
};
